import { render } from "./ImageViewer.vue?vue&type=template&id=5266c9da&ts=true"
import script from "./ImageViewer.vue?vue&type=script&lang=ts"
export * from "./ImageViewer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/ImageViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5266c9da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5266c9da', __exports__)) {
    api.reload('5266c9da', __exports__)
  }
  
  module.hot.accept("./ImageViewer.vue?vue&type=template&id=5266c9da&ts=true", () => {
    api.rerender('5266c9da', render)
  })

}


export default __exports__